
window.addEventListener("load", (event) => {
  
  document.querySelector('.load-more').classList.add('hide');

  if(window.innerWidth > 500) {

    // Get all elements with the class 'slider-item'
    var sliderItems = document.querySelectorAll('.custom-slider-wrapper .custom-slider-section');
    
    // Iterate over the NodeList
    sliderItems.forEach(function(item, index) {
        // Get the id of each element
        var itemId = item.id;
        console.log(itemId); // Or do whatever you want with the id
  
      gsap.registerPlugin(ScrollTrigger);
      var rule = CSSRulePlugin.getRule(`#${itemId} .custom-slider-content > h5::after`);
      var rule2 = CSSRulePlugin.getRule(`#${itemId} .custom-slider-content > h2::after`);
      var rule3 = CSSRulePlugin.getRule(`#${itemId} .custom-slider-content > p::after`);
      gsap.from(`#${itemId} .custom-slider-content`, {
        scrollTrigger: {
          trigger: `#${itemId} .custom-slider-content`,
          toggleActions: 'restart none restart none'
        }, 
        duration: 1, 
        y: -150, 
        opacity: 0
      });
      gsap.to(rule, {
        scrollTrigger: {
          trigger: `#${itemId} .custom-slider-content`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
      gsap.to(rule2, {
        scrollTrigger: {
          trigger: `#${itemId} .custom-slider-content`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
      gsap.to(rule3, {
        scrollTrigger: {
          trigger: `#${itemId} .custom-slider-content`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
      
    });
  
    var rule4 = CSSRulePlugin.getRule(`.video-section .overlay h1::after`);
    var rule5 = CSSRulePlugin.getRule(`.video-section .overlay p::after`);
    gsap.from(`.video-section .overlay`, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        }, 
        duration: 1, 
        y: -150, 
        opacity: 0
      });
    gsap.to(rule4, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
    gsap.to(rule5, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
    
  } else {

    var sliderItems = document.querySelectorAll('.main-se .sec-1');
    
    // Iterate over the NodeList
    sliderItems.forEach(function(item, index) {
        // Get the id of each element
        var itemId = item.id;
        console.log(itemId); // Or do whatever you want with the id
  
      gsap.registerPlugin(ScrollTrigger);
      var rule = CSSRulePlugin.getRule(`#${itemId}.sec-1 .position h2::after`);
      var rule2 = CSSRulePlugin.getRule(`#${itemId}.sec-1 .position p::after`);
      gsap.from(`#${itemId}.sec-1 .position`, {
        scrollTrigger: {
          trigger: `#${itemId}.sec-1 .position`,
          toggleActions: 'restart none restart none'
        }, 
        duration: 1, 
        y: -150, 
        opacity: 0
      });
      gsap.to(rule, {
        scrollTrigger: {
          trigger: `#${itemId}.sec-1 .position`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
      gsap.to(rule2, {
        scrollTrigger: {
          trigger: `#${itemId}.sec-1 .position`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
      
    });
  
    var rule3 = CSSRulePlugin.getRule(`.video-section .overlay h1::after`);
    var rule4 = CSSRulePlugin.getRule(`.video-section .overlay p::after`);
    gsap.from(`.video-section .overlay`, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        }, 
        duration: 1, 
        y: -150, 
        opacity: 0
      });
    gsap.to(rule3, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
    gsap.to(rule4, {
        scrollTrigger: {
          trigger: `.video-section .overlay`,
          toggleActions: 'restart none restart none'
        },
        cssRule: {scaleY: 0}, 
        duration: 1.2, 
        delay: 0.5
      });
    
  }



  if (window.innerWidth < 480) {

   $('.cstm-right-texti').slick({
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots:true,
          slidesToShow: 1.1,
          slidesToScroll: 1
        }
      }
    ]
  });






   $('#section-template--23543161979201__imagewithtext_1_VGm8z8').slick({
    arrows: false,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots:true,
          numbers:true,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  });

















    

  
}





  
  
});

